<div class="container">
  <app-general-header
    [title]="'Manage ' + ((district && district.title) || 'District')" />
  <app-settings-nav [districtCode]="districtCode" />
  <div class="card border-0 p-3">
    <div class="row d-flex justify-content-between my-3 px-xl-5">
      <div
        class="row d-flex align-items-center col-12 col-lg-8 order-2 order-md-1">
        <div class="col-12 col-md-5">
          <input
            type="search"
            class="form-control ms-1"
            placeholder="Search Forms"
            aria-label="Search"
            (input)="searchTermChanged($event)" />
        </div>
        <div
          class="col-12 col-md-5 text-center text-md-end form-check form-switch mx-3">
          <div class="d-flex align-items-center my-3 my-md-0 mx-auto mx-md-0">
            <input
              class="form-check-input me-2"
              type="checkbox"
              [checked]="!currentMode"
              (click)="toggleFormView()"
              id="currentViewToggle" />
            <label class="text-body-secondary" for="currentViewToggle"
              >View archived forms</label
            >
          </div>
        </div>
      </div>
      <div
        class="text-center text-lg-end col-12 col-lg-4 mb-3 mb-lg-0 order-1 order-md-2">
        <button
          (click)="createForm()"
          [disabled]="isCreating"
          class="btn btn-primary px-4">
          <ng-container *ngIf="isCreating">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </ng-container>
          <i class="bi bi-plus"></i> Create Form
        </button>
      </div>
    </div>
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <div class="table-wrapper w-100 mt-3 px-xl-5">
        <table
          *ngIf="forms && forms.length > 0; else noResults"
          class="table gl-striped-table my-4">
          <!--TABLE HEADER-->
          <thead>
            <tr class="align-middle">
              <th scope="col">Title</th>
              <th class="no-wrap" scope="col">Owner</th>
              <th class="no-wrap" scope="col">Type</th>
              <th class="no-wrap" scope="col">Status</th>
              <th class="no-wrap" scope="col">Activity</th>
              <th class="np-wrap" scope="col"></th>
            </tr>
          </thead>
          <!--TABLE BODY-->
          <tbody>
            <tr *ngFor="let form of forms" class="align-middle">
              <td>
                <span class="fw-600 color-primary"
                  >@if(form.is_locked) {
                  <i
                    ngbTooltip="e2L has locked this form"
                    class="bi bi-lock-fill me-2"></i>
                  }{{ form.title }}</span
                >
              </td>
              <td>
                {{ form.district?.title }}
                <div
                  class="d-inline-block ms-2 p-1 ps-2 fs-12 bg-secondary rounded cursor-pointer"
                  *ngIf="district.id !== form.district_id"
                  [ngbPopover]="formHideConfirm"
                  [popoverTitle]="'Hide Form'"
                  [autoClose]="'outside'"
                  #popover="ngbPopover">
                  <ng-template #formHideConfirm>
                    Hide this shared form from your district?
                    <div class="text-end mt-2">
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm px-3 m-1"
                        (click)="popover.close()">
                        No
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm px-3 m-1"
                        (click)="hideForm(form.id); popover.close()">
                        Yes
                      </button>
                    </div>
                  </ng-template>
                  Hide form
                  <i class="bi bi-eye-slash p-1"></i>
                </div>
              </td>
              <td>
                {{ form.type }}
              </td>
              <td>
                {{ form.status.toLowerCase() }}
              </td>
              <td class="submission-col">
                <ng-container
                  *ngIf="
                    form.submissionCount && form.submissionCount > 0;
                    else noSubmissionBlock
                  ">
                  <button
                    ngbTooltip="View submissions"
                    class="btn btn-link color-tertiary p-0"
                    (click)="
                      showSubmissionModal(
                        form.id,
                        form.title,
                        form.type === ProFormType.QUIZ
                      )
                    ">
                    {{ form.submissionCount }} submissions
                  </button>
                </ng-container>
                <ng-template #noSubmissionBlock
                  ><div class="no-wrap">0 submissions</div></ng-template
                >
              </td>
              <td class="edit-col">
                <button
                  ngbTooltip="Preview"
                  (click)="previewForm(form.id)"
                  class="btn btn-link color-tertiary p-1">
                  <i class="bi bi-eye p-1"></i>
                </button>
                <button
                  ngbTooltip="Copy"
                  (click)="duplicateForm(form.id, form.title)"
                  class="btn btn-link color-tertiary p-1">
                  <i class="bi bi-copy"></i>
                </button>
                @if(userCanEdit(form)){
                <button
                  ngbTooltip="Edit"
                  (click)="
                    this.router.navigate(['proforms', 'form-builder', form.id])
                  "
                  class="btn btn-link color-tertiary p-1">
                  <i id="edit-{{ form.title }}" class="bi bi-pencil"></i>
                </button>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <section>
        <div class="d-flex justify-content-center">
          <ngb-pagination
            *ngIf="pagination && pagination.totalCount > 10"
            [(page)]="pagination.currentPage"
            [pageSize]="pagination.perPage"
            [collectionSize]="pagination.totalCount"
            [maxSize]="5"
            (pageChange)="pageChange($event)"></ngb-pagination>
        </div>
      </section>
      <ng-template #noResults>
        <div
          class="w-100 p-5 text-center d-flex justify-content-center align-items-center"
          style="min-height: 300px">
          <div class="xtext-center xtext-body-secondary">
            <p *ngIf="district && district.id === 2">
              No templates created yet
            </p>
            <p *ngIf="!district || district.id != 2">
              There are no matching forms associated with your district.
            </p>
          </div>
        </div>
      </ng-template>
      <app-proforms-submissions-modal
        [formId]="submissionModalId"
        [formTitle]="submissionModalTitle"
        [isQuiz]="isQuiz"
        #submissionModal />
      <app-proform-preview-modal
        #previewModal
        [formId]="selectedPreviewFormId" />
    </ng-container>
    <ng-template #loadingTemplate>
      <div style="clear: both; height: 300px"></div>
      <app-loader [top]="200" />
    </ng-template>
    <!-- </div> -->
  </div>
</div>
